import React from 'react';
import { Card } from 'react-bootstrap';
import { RootCauseCategory, FurtherConsiderations } from '../../models';

type Props = {
    furtherConsiderations: FurtherConsiderations;
};

export class DisclaimerSection extends React.Component<Props, {}> {
    disclaimer = () => {
        return (
            <span>
                {
                    this.furtherConsiderationsFor(RootCauseCategory.CATEGORY_999)
                }
            </span>
        );
    }

    furtherConsiderationsFor(rootCauseCategory: RootCauseCategory): JSX.Element {
        const { furtherConsiderations } = this.props;
        return (
            <span key={rootCauseCategory}>
                {
                    furtherConsiderations.findConsiderations(rootCauseCategory).map((consideration, cindex) => {
                        return (
                            <span key={cindex}>
                                <span key={`title-${cindex}`} className="consideration-title">
                                    {consideration.title}
                                </span>
                                <ul className="disclaimer-ul">
                                {
                                    consideration.items.map((item, itemIndex) => {
                                        return <li className="disclaimer-text" key={`${rootCauseCategory}-${cindex}-${itemIndex}`}>{item}</li>;
                                    })
                                }
                                </ul>
                            </span>
                        );

                    })
                }
            </span>
        );  
    }

    render() {
        return (
            <div style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                <Card className="disclaimer-panel">
                    <Card.Header>Disclaimer</Card.Header>
                    <Card.Body className="disclaimer-body note-card-body report-disclaimer-body">
                        {this.disclaimer()}
                    </Card.Body>
                </Card>
            </div>
        );
    }
}